module.exports = __webpack_public_path__ + "static/media/cms.0af0ae6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/cms.png
// module id = 1530
// module chunks = 1